import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  ChangeDetectorRef, signal
} from "@angular/core";
import { DevicesComponent } from "../devices/devices.component";
import {
  CommonModule,
  DOCUMENT,
  NgOptimizedImage,
  isPlatformBrowser,
} from "@angular/common";
import { LeftStorageNavComponent } from "../left-storage-nav/left-storage-nav.component";
// import { API_RESPONSE } from "../../core/services/constants";
import { BehaviorSubject, Subscription, debounceTime, fromEvent } from "rxjs";
import { LoadingComponent } from "../../shared/loading/loading.component";
import { ApiHandlerService } from "../../core/services/apiCall.service";
import { jwtDecode } from "jwt-decode";
import { Router } from "@angular/router";
import { AuthService } from "../../core/services/auth.service";
import { SelectedDevicesService } from "../../core/services/device-selection.service";


interface DecodedToken {
  exp: number;
}
@Component({
  selector: "app-home",
  standalone: true,
  imports: [
    LeftStorageNavComponent,
    CommonModule,
    DevicesComponent,
    LoadingComponent,
    NgOptimizedImage,
  ],
  templateUrl: "./home.component.html",
  styleUrl: "./home.component.scss",
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeComponent implements OnInit {
  // apiResponseData: any = API_RESPONSE;
  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  showDevices = false;
  planHasDevices: any = [];  // subscriptions list
  shopCampatibleDevices = true;
  planDevices: boolean = false;
  planDetails: boolean = false; // tis not on template view remove n later
  // existingPlan: boolean = true; 
  existingPlanToNew: boolean = false; //check existing plan to new on web
  @ViewChild("screenSize") screenSizeElement!: ElementRef;
  isMobile = false; // check mobile screen
  newPlanDevicesForMobile: boolean = false; // new plan devices on mobile
  existingPlanDevicesForMobile: boolean = false;
  existingPlanToNewForMobile: boolean = false; // cgo to existing plan to new on Mobile
  planHaveNoDevices: any = []; // have subscriptio and plan bt no devices
  checkPlanHaveNoDevices: any = true;
  showMenu: any = true;
  resizeListener!: EventListenerOrEventListenerObject;
  statusForCheckSuccess: boolean = true // chnage accordinglt later
  devicesLIst: any = [] ;
  incompatibleDevices: any = [];
  stopToClick: boolean = false
  resizeSubscription!: Subscription;
  isUserOpenAddNewPlan = false;


  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private service: ApiHandlerService,
    private authService: AuthService,
    private selectionService: SelectedDevicesService

  ) {
    this.resizeListener = this.checkMobileView.bind(this);

  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.checkMobileView(); // Initial check on load
      this.resizeSubscription = fromEvent(window, 'resize')
        .pipe(debounceTime(200)) // Debounce for 200 milliseconds
        .subscribe(() => this.checkMobileView());
    }

    if (typeof window !== 'undefined' && window.localStorage) {
      const user = localStorage.getItem("user");
      if (user) {
        this.getSubscriptons(user);
        this.getAssets(user)
        this.checkTokenExpiration()
      }
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      window.removeEventListener("resize", this.resizeListener); // Remove event listener on component destruction
    }
  }


  checkMobileView = () => {
    if (isPlatformBrowser(this.platformId)) {
      const isCurrentlyMobile = window.innerWidth < 692;
      if (isCurrentlyMobile !== this.isMobile) {
        this.isMobile = isCurrentlyMobile;
        this.cdr.detectChanges();

      }
    }
  };

  addNewPlanButtonClicked(){
      this.showDevices = true;
      this.showMenu = false;
  }

  handlePlanDevicesChange(newPlanDevices: boolean) {
    const modifiedValue = newPlanDevices ? true : false; // Example modification
    this.planDevices = modifiedValue;
    this.newPlanDevicesForMobile = modifiedValue;
    this.isLoading$.next(false);

  }

  handlePlanDetails(planDetails: any) {
    const modifiedValue = planDetails ? true : false;
    this.planDetails = modifiedValue;
  }

  handleSwitch(event: any) {
    const modifiedValue = event ? true : false;
    this.existingPlanToNew = modifiedValue;
    this.existingPlanToNewForMobile = modifiedValue;
    // this.isLoading$.next(false);

  }

  getSubscriptons(user: string) {
    this.isLoading$.next(true);
    this.service.Get(`subscriptions/getallusersubscriptions?user=${user}`).subscribe(
      (data: any) => {
        this.planHasDevices = data;
        this.isLoading$.next(false);
      },
      (error: any) => {
        this.isLoading$.next(false);

      }
    )
  }
  checkTokenExpiration() {
    const tokens = localStorage.getItem("tokens");
    if (tokens) {
      const parsedToken = JSON.parse(tokens);
      const decoded: DecodedToken = jwtDecode(parsedToken?.authorization);

      const expirationTime = new Date(decoded?.exp * 1000)
      const currentTime = new Date();
      const twelveHoursInMillis = 12 * 60 * 60 * 1000;
      const expirationPlus12Hours = new Date(expirationTime.getTime() + twelveHoursInMillis);
      if (currentTime > expirationPlus12Hours) {
        this.cleanup()
      }
    }
  }


  getAssets(user: string) {
    this.isLoading$.next(true);
    this.service.Get(`devices/userassets?user=${user}`).subscribe(
      (data: any) => {
        if(data.code == 401){
          this.authService.logout();
          this.router.navigate(['/login']);
        }
        this.devicesLIst = data?.data?.devices ?? [];
        this.incompatibleDevices = this.devicesLIst.filter((device:any) => device?.subscription && Object.keys(device.subscription).length > 0);
        this.devicesLIst = this.devicesLIst.filter((device:any) => !device?.subscription || Object.keys(device.subscription).length === 0);
        this.selectionService.setAssetDevices(data?.data?.devices || [])
        this.isLoading$.next(false);

      },
      (error: any) => {
       this.isLoading$.next(false);
      }
    );

  }

  cleanup() {
    localStorage.removeItem('tokens');
    localStorage.removeItem('user');
    localStorage.removeItem('authStatus');
    localStorage.removeItem('selectedCountry');
    this.router.navigate(['/login']);
  }
  goToShop() {
    window.open(
      "https://lorex.com?utm_source=cloud_portal&utm_campaign=shop_now",
      "_blank"
    );
  }
  goToApp() {
    window.open("https://app.lorex.com/home/download", "_blank");
  }
}
